import '../styles/social-icons.css';
import '../styles/footer.css';
import socialLinks from '../data/socialLinks.json';
import { Link } from 'react-router-dom';
import GoogleTagManager from '../components/GoogleTagManager';
import { GTM_ID } from '../config/analytics';
import { APP_VERSION } from '../config/constants';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <GoogleTagManager id={GTM_ID} />
      <div className="footer-content footer-top">
        <div className="footer-brand">
          <img
            src="/images/lwt.png"
            alt="Lead With Tech"
            style={{ width: '64px', height: '64px', objectFit: 'contain' }}
          />
          <p className="footer-about">
            We don&apos;t just teach code. We teach the mindset required to lead for engineers
            becoming architects, leaders and AI-powered developers.
          </p>
          <div className="social-links">
            {socialLinks.links.map((link) => (
              <a
                key={link.platform}
                href={link.url}
                className={`social-icon ${link.platform}`}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={link.platform.charAt(0).toUpperCase() + link.platform.slice(1)}
              >
                <svg
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                     dangerouslySetInnerHTML={{ __html: link.icon }} />
              </a>
            ))}
          </div>
        </div>

        <div className="footer-section">
          <h3>PROGRAMS</h3>
          <ul className="footer-links">
            <li><a href="/#flagship">Flagship Programs</a></li>
            <li><a href="/#certifications">Certification Programs</a></li>
            <li><a href="/#career">Career Authoring</a></li>
            <li><Link to="/events">Events</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>COMPANY</h3>
          <ul className="footer-links">
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/jobs">Jobs</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
            <li><Link to="/blog">Blog</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>SUPPORT</h3>
          <ul className="footer-links">
            <li><Link to="/terms">Terms &amp; Conditions</Link></li>
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><Link to="/refund">Cancellation &amp; Refunds</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>CONNECT</h3>
          <ul className="footer-links">
            {socialLinks.links.map((link) => (
              <li key={`connect-${link.platform}`}>
                <a href={link.url} target="_blank" rel="noopener noreferrer">
                  {link.platform.charAt(0).toUpperCase() + link.platform.slice(1)}
                </a>
              </li>
            ))}
            <li><Link to="/community">Community</Link></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <span className="copyright">
          &copy; {currentYear} Lead With Tech. All rights reserved.
        </span>
        <span className="footer-tagline">
          Empowering engineers to innovate, inspire and lead.
        </span>
        <p className="footer-version">
          v{APP_VERSION}
        </p>
      </div>
    </footer>
  );
}

export default Footer;